export default "__VITE_ASSET__qfqroCMm__"